export default function BottomBar() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50">
      {/* Mobile sticky bar */}
      <div className="md:hidden bg-gradient-to-t from-[#e6f7f5] via-[#e6f7f5]/95 to-transparent pt-4 pb-4 px-4">
        <div className="flex items-center gap-3 max-w-md mx-auto">
          <a
            href="tel:+33187668155"
            className="flex-1 flex items-center justify-center gap-2 bg-brand-accent hover:opacity-90 text-white font-semibold text-sm min-h-[48px] px-5 rounded-full shadow-lg shadow-brand-accent/25 transition-all active:scale-[0.97] whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill text-base"></i>
            Appeler
          </a>
          <a
            href="https://wa.me/+33745883392?text=Bonjour%20DF%20PRO"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1faa52] text-white font-semibold text-sm min-h-[48px] px-5 rounded-full shadow-lg shadow-[#25D366]/25 transition-all active:scale-[0.97] whitespace-nowrap cursor-pointer animate-pulse"
          >
            <i className="ri-whatsapp-fill text-base"></i>
            WhatsApp
          </a>
        </div>
      </div>

      {/* Desktop WhatsApp floating button */}
      <div className="hidden md:block fixed bottom-6 right-6 z-50">
        <a
          href="https://wa.me/+33745883392?text=Bonjour%20DF%20PRO"
          target="_blank"
          rel="noopener noreferrer"
          className="w-14 h-14 flex items-center justify-center bg-[#25D366] hover:bg-[#1faa52] text-white rounded-full shadow-xl shadow-[#25D366]/30 transition-all hover:scale-110 cursor-pointer animate-pulse"
          aria-label="WhatsApp"
        >
          <i className="ri-whatsapp-fill text-2xl"></i>
        </a>
      </div>
    </div>
  );
}